import styles from './Modal.module.css';
import { CloseIcon, Group, Modal as MantineModal, ModalProps as MantineModalProps } from '@mantine/core';
import { StatusWarningIcon } from 'icons/StatusWarningIcon';
import { joinClassNames } from 'utils/joinClassNames';
import { variants } from 'components/styles/button/variants';

interface ModalProps extends MantineModalProps {
    /**
     * Whether to show the warning icon in the title
     */
    showWarningIcon?: boolean;
}

export const Modal = ({
    children,
    classNames,
    className,
    title,
    showWarningIcon,

    ...props
}: ModalProps) => {
    return (
        <MantineModal
            className={joinClassNames(styles.root, className)}
            classNames={{
                title: styles.title,
                close: styles.close,
                content: styles.content,
                ...classNames,
            }}
            title={
                showWarningIcon ? (
                    <Group gap={8}>
                        <StatusWarningIcon fill="var(--graphic-status-caution)" />
                        {title}
                    </Group>
                ) : (
                    title
                )
            }
            closeButtonProps={{
                'className': variants({ intent: 'neutral', appearance: 'ghost' }),
                'size': 36,
                'style': {
                    borderRadius: '50%',
                    color: 'var(--graphic-interactive-neutral-resting)',
                },
                'iconSize': 16,
                'aria-label': 'Close Modal',
                'icon': <CloseIcon />,
            }}
            {...props}
        >
            {children}
        </MantineModal>
    );
};
